"use strict";

var _regeneratorRuntime = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAddsomeUsers = exports.createNotifications = exports.thunks = exports.reducer = void 0;

var crud_1 = require("./crud");

var notification_1 = require("./notification");

var api_1 = require("../api");

var KEY = 'ADDSOME_USER';
exports.reducer = (0, crud_1.default)(KEY);
exports.thunks = new crud_1.ThunkHandler({
  url: '/addsome-users',
  key: KEY
});

function createNotifications(dispatch, message) {
  dispatch((0, notification_1.addLabels)(KEY, {
    fetchValues: {
      error: message.errorRetrievingAddsomeUsers
    },
    fetchValue: {
      error: message.errorRetrievingAnAddsomeUser
    },
    patch: {
      success: message.updatedAddsomeUser,
      error: message.errorRegisteringAddsomeUser
    },
    delete: {
      success: message.addsomeUserRemoved,
      error: message.errorDeletingAddsomeUser
    }
  }));
}

exports.createNotifications = createNotifications;

var fetchAddsomeUsers = function fetchAddsomeUsers(request) {
  return function () {
    return __awaiter(void 0, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var queryParams, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryParams = (0, api_1.makeQueryPagination)(request);
              _context.prev = 1;
              _context.next = 4;
              return (0, api_1.apiRequest)('GET', '/addsome-users', undefined, queryParams);

            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 11:
              return _context.abrupt("return", []);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
  };
};

exports.fetchAddsomeUsers = fetchAddsomeUsers;